import React from 'react';
import { Typography, Button, Toolbar , Select} from '@material-ui/core';
import { useStyles } from './SettingStyle';
import infoIcon from "../../assets/icons/infoIcon.png";
import DoneIcon from '@material-ui/icons/Done';
import AddIcon from '../../assets/icons/AddIcon.png';
import DelIcon from '../../assets/icons/DelIcon.png';

export default function Setting() {
  const classes = useStyles();
  const [age, setAge] = React.useState('');
  const handleChange = (event) => {
    setAge(event.target.value);
  };
  return (
    <>
      <Toolbar disableGutters className={classes.toolbarContainer}>
          <Typography
            variant="h6"
            component="div"
            noWrap={true}
            className={classes.toolbarText}
          >
            Project Settings
          </Typography>
        <Button
          variant="contained"
          size="medium"
          className={classes.button}
          classes={{root:classes.btnRoot}}
        >
          Remove Project
        </Button>
      </Toolbar>

      <div className={classes.settingContainer}>
        <div className={classes.inputContainer}>
          <div className={classes.icon_p}>
          <p className={classes.p_tag}>Project Name</p>
            <img
              src={infoIcon}
              width={15}
              height={15}
              style={{ marginLeft:11 , marginTop: 0 }}
              alt="imagelogo"
            />
          </div>
        </div>
        <div className={classes.IconAndInputField}>
            <input
              type="text"
              className={classes.Input}
              value={'securityscorecard-257a'}
              placeholder="Enter Project Name"
            />
            <DoneIcon  style={{width:18 , height: 18 , color: 'green'}}/>
          </div>
          <div  className={classes.customMargin} />
          <div className={classes.icon_p}>
          <p className={classes.p_tag}>Account</p>
            <img
              src={infoIcon}
              width={15}
              height={15}
              style={{ marginLeft:11 }}
              alt="imagelogo"
            />
          </div>

          <div  className={classes.IconAndSelectField}>
          <Select
            className={classes.selectField}
            classes={{root: classes.selectSelected}}
            disableUnderline
            autoWidth={false}
            native
            value={age}
            onChange={handleChange}
            inputProps={{
              name: 'age',
              id: 'age-native-simple',
            }}
          >
            <option aria-label="None" value="" />
            <option value={10}>Account-12</option>
            <option value={10}>Account-13</option>
            <option value={10}>Account-14</option>
          </Select>
          </div>

          <div  className={classes.customMargin} />
          <div className={classes.icon_p}>
          <p className={classes.p_tag}>Technical Emails</p>
            <img
              src={infoIcon}
              width={15}
              height={15}
              style={{ marginLeft:11 }}
              alt="imagelogo"
            />
          </div>
        <div className={classes.IconAndInputField}>
            <input
              type="text"
              className={classes.Input}
              placeholder="type email and press enter...."
            />
          </div>
          <div  className={classes.customMargin} />
          <div className={classes.icon_p}>
          <p className={classes.p_tag}>Billing Reference Tags</p>
            <img
              src={infoIcon}
              width={15}
              height={15}
              style={{ marginLeft:11 }}
              alt="imagelogo"
            />
          </div>

          <div className={classes.doubleInput}>
          <div className={classes.InputField}>
            <input
              type="text"
              className={classes.Input}
              placeholder="Add key"
            />
          </div>
          <div className={classes.InputField}>
            <input
              type="text"
              className={classes.Input}
              placeholder="Add value"
            />
          </div>
          <img src={AddIcon}  style={{width: 28 , height: 28}} alt='addImg'/>
          </div>
          <div className={classes.twentyMargin} />
          <div className={classes.doubleInput}>
          <div className={classes.InputField} style={{backgroundColor: '#D4DDE4' , border: '1px solid #D4DDE4'}}>
            <input
              type="text"
              className={classes.Input}
              style={{backgroundColor: '#D4DDE4', width: '100%'}}
              value={'OMAR565125'}
              placeholder="Add key"
            />
          </div>
          <div className={classes.InputField} style={{backgroundColor: '#D4DDE4', border: '1px solid #D4DDE4'}}>
            <input
              type="text"
              className={classes.Input}
              style={{backgroundColor: '#D4DDE4', width: '100%'}}
              value={'5842154254152F51'}
              placeholder="Add value"
            />
          </div>
          <div style={{width: 28 , height: 28, textAlign: 'right'}}>
          <img src={DelIcon}  style={{width: 24 , height: 25}} alt='delImg'/>
          </div>
          </div>
          <div  className={classes.customMargin} />
          <div className={classes.icon_p}>
          <p className={classes.p_tag}>Project Tags</p>
            <img
              src={infoIcon}
              width={15}
              height={15}
              style={{ marginLeft:11 }}
              alt="imagelogo"
            />
          </div>
          <div className={classes.doubleInput}>
          <div className={classes.InputField}>
            <input
              type="text"
              className={classes.Input}
              placeholder="Add key"
            />
          </div>

          <div className={classes.InputField}>
            <input
              type="text"
              className={classes.Input}
              placeholder="Add value"
            />
          </div>
          <img src={AddIcon}  style={{width: 28 , height: 28}} alt='addImg'/>

          </div>
          <div className={classes.twentyMargin} />
          <div className={classes.doubleInput}>
          <div className={classes.InputField} style={{backgroundColor: '#D4DDE4', border: '1px solid #D4DDE4'}}>
            <input
              type="text"
              className={classes.Input}
              style={{backgroundColor: '#D4DDE4', width: '100%'}}
              value={'OMAR565125'}
              placeholder="Add key"
            />
          </div>
          <div className={classes.InputField} style={{backgroundColor: '#D4DDE4', border: '1px solid #D4DDE4'}}>
            <input
              type="text"
              className={classes.Input}
              style={{backgroundColor: '#D4DDE4', width: '100%'}}
              value={'5842154254152F51'}
              placeholder="Add value"
            />
          </div>
          <div style={{width: 28 , height: 28, textAlign: 'right'}}>
          <img src={DelIcon}  style={{width: 24 , height: 25 }} alt='delImg'/>
          </div>
          </div>
          <div  className={classes.customMargin} />
          <div className={classes.btnContainer}>
            <Button
            disableElevation={true}
              variant="contained"
              size="large"
              className={classes.btnOne}
              classes={{root:classes.btnRoot}}
            >
              Cancel
            </Button>
            <div className={classes.rightMargin} />
            <Button
            disableElevation={true}
              variant="contained"
              color="inherit"
              size="large"
              className={classes.btnTwo}
              classes={{root:classes.btnRoot}}
            >
              Save Changes
            </Button>
          </div>

      </div>

    </>

  );
}
